import { render, staticRenderFns } from "./PayrollTableAlt.vue?vue&type=template&id=0b535a94&scoped=true&"
import script from "./PayrollTableAlt.vue?vue&type=script&lang=js&"
export * from "./PayrollTableAlt.vue?vue&type=script&lang=js&"
import style0 from "./PayrollTableAlt.vue?vue&type=style&index=0&id=0b535a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b535a94",
  null
  
)

export default component.exports